import { Code } from 'constants/keyboard';
import { KeyboardEvent, RefObject } from 'react';
import { TFunction } from 'react-i18next';

import { DropdownPopoverOptionProps } from './DropdownPopoverOption';

type TranslationOptions = Array<DropdownPopoverOptionProps & { labelProps?: Record<string, unknown> }>;

export const stopPropagationHandler =
  (triggerRef: RefObject<HTMLButtonElement>) => (e: KeyboardEvent<HTMLDivElement>) => {
    // Accessbility: Allow tabbing to next element
    if (e.key === Code.Tab) return;

    // Accessbility: Allow spacebar or enter to open the dropdown
    // This is used on other dropdowns and chakra ui select.
    // However, we may review this becasue native select does not allow spacebar or enter to open the dropdown
    if (e.key === Code.Enter || e.key === Code.Space) return;

    // Accessbility: Allow escape popping up to the parents to close other panel such as side panel
    if (e.key === Code.Escape && e.target === triggerRef.current) return;

    // Accessbility: Allow escape to close the dropdown and focus on the dropdown trigger when dropdown is opened
    if (e.key === Code.Escape && e.target !== triggerRef.current) {
      // Prevent descendant elements such as side panel from closing when the dropdown is opened and escape is pressed
      e.stopPropagation();
      e.preventDefault();

      // Focus on the dropdown trigger while dropdown is opened and escape is pressed
      triggerRef.current?.focus();
    }

    // Prevent the events keyboard events in the dropdown from bubbling up to the parent elements
    e.stopPropagation();
    e.preventDefault();
  };

export const generateTranslatedOptions = (t: TFunction, options: TranslationOptions, prefix?: string) => {
  return options.map((opt) => {
    let label = opt.label;
    if (prefix) {
      label = `${prefix}.${label}`;
    }
    return {
      ...opt,
      label: t(label as keyof typeof t, opt.labelProps || {}),
    };
  });
};
